// deps
import React, { ReactElement, useContext, memo, useCallback } from "react";

// internal deps
import { Alert } from "@swiggy-private/cart-ui";
import { GenericAlertProps } from "@swiggy-private/cart-types";
import { CheckoutContext, CheckoutActionTypes } from "@swiggy-private/checkout-core";

function GenericAlert(props: GenericAlertProps): ReactElement | null {
    const { setCheckoutState } = useContext(CheckoutContext);

    const onOverlayClose = useCallback(() => {
        setCheckoutState({ type: CheckoutActionTypes.SHOW_CART, payload: null });
    }, [setCheckoutState]);

    return (
        <Alert
            {...props}
            hideOnOverlayClick={props.hideOnOverlayClick ?? true}
            onClose={props.onClose ?? onOverlayClose}
        />
    );
}

export default memo(GenericAlert);
